import { useCallback } from 'react';
import { PromptGroup_deprecated, PromptGroup } from '@server/prompts';
import { usePromptGroups } from './usePromptGroups';
import { CategoryData } from './types';

export const useCategoryActions = (categories: (PromptGroup_deprecated | PromptGroup)[]) => {
  const { loadPromptGroups, createPromptGroup, updatePromptGroup, removePromptGroup, pinGroup } =
    usePromptGroups();

  const handleCreateCategory = useCallback(
    async (data: CategoryData, iconName: string) => {
      return createPromptGroup({
        id: '',
        name: data.name,
        iconName,
        isPinned: false,
        description: data.description,
        accountId: '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      });
    },
    [createPromptGroup],
  );

  const handleEditCategory = useCallback(
    async (categoryId: string, data: CategoryData, iconName: string) => {
      const category = categories.find((c) => c.id === categoryId);
      if (category) {
        return updatePromptGroup({
          ...category,
          name: data.name,
          description: data.description,
          iconName,
        });
      }
      return null;
    },
    [updatePromptGroup, categories],
  );

  const handleDeleteCategory = useCallback(
    async (categoryId: string) => {
      await removePromptGroup(categoryId);
    },
    [removePromptGroup],
  );

  const handlePinCategory = useCallback(
    async (categoryId: string) => {
      await pinGroup(categoryId, true);
    },
    [pinGroup],
  );

  const handleUnpinCategory = useCallback(
    async (categoryId: string) => {
      await pinGroup(categoryId, false);
    },
    [pinGroup],
  );

  return {
    fetchCategories: loadPromptGroups,
    handleCreateCategory,
    handleEditCategory,
    handleDeleteCategory,
    handlePinCategory,
    handleUnpinCategory,
  };
};
